module.exports = __webpack_public_path__ + "static/img/products.b6656c25.jpg";